export default "__VITE_ASSET__4418fac6__"